<template>
    <div class="d-inline">
        <span class="text-success ml-1" v-if="mostrarIconeFinanceiro">
            <i
                class="fa fa-check-circle fa-lg"
                title="Processo Recebido/Quitado"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        comprometimento: Object
    },

    data() {
        return {}
    },

    computed: {
        mostrarIconeFinanceiro() {
            return (
                this.comprometimento &&
                (this.comprometimento.statusIdFaturamento == 'F' ||
                    this.comprometimento.statusIdFaturamento == 'Q')
            )
        }
    }
}
</script>
